import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tax-info" }
const _hoisted_2 = { class: "material" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = { key: 1 }

import { Dialog } from 'vant'
import { computed, onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import useOpenInfo from '@/hooks/openInfo'
import TaxCard from './components/TaxCard.vue'
import stepPercentage from '@/utils/number'
import { setApptitle } from '@/utils/native-app'
import * as storage from '@/utils/storage'
import { useMutation, useQuery } from '@vue/apollo-composable'
import { queryApi } from '@/graphql/query'
import { dobuleSaveDraft } from '@/graphql/mutation'
import { FormType } from '@/enum'

interface TaxType {
  taxCountry: string
  taxNumber: string
  hasTaxNumber: number
  reasonType: string
  reasonDesc: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
// vuex store数据
const {
  openType,
  openInfo,
  meta,
  title,
  step,
  saveOpenInfoOfVuex,
  saveCommonOfVuex
} = useOpenInfo() // 用户信息回填
const form: any = reactive({
  openAccountTaxationList: [],
  isAmericanGreenCardHolder: 0,
  disclosureType1: [12, 36, 37, 38]
})
const disclousreList = ref()
const taxArr: number[] = reactive([])
const commomParams = ref()
// 获取storage中的formType,用来区分普通开户和投资移民户
const formTypeVal = computed(() => storage.get('formType'))

const addTax = () => {
  taxArr.push(1)
}

const initData = async () => {
  Object.keys(form).forEach(val => {
    const res = openInfo.value[val] ? openInfo.value[val] : form[val]
    form[val] = res
    taxArr.length =
      form.openAccountTaxationList.length !== 0 ? form.openAccountTaxationList.length - 1 : 0
  })
  console.log(form)
  if (!form.openAccountTaxationList[0].taxCountry) {
    const { idKind } = openInfo.value
    if (idKind === 1) {
      form.openAccountTaxationList[0].taxCountry = '中国大陆'
    }
    if (idKind === 2 || idKind === 3) {
      form.openAccountTaxationList[0].taxCountry = '中国香港'
    }
  }
}
const radioGroup = [
  {
    text: '否',
    name: 0
  },
  {
    text: '是',
    name: 1
  }
]

// 税务信息弹窗
const show = ref(false)
const fundAccountType = ref(1)
const closePopup = (val: boolean) => {
  show.value = val
}
const changeTax = (val: never) => {
  form.openAccountTaxationList.splice(0, 1, val)
}
const changeTax2 = (val: never, index: number) => {
  form.openAccountTaxationList.splice(index, 1, val)
}
const deleteTax = (v: number) => {
  taxArr.splice(v - 1, 1)
  form.openAccountTaxationList.splice(v, 1)
}
// 是否美国公民
const changeRadio = (val: number) => {
  if (val === 1) {
    Dialog.alert({
      title: '提示',
      message: '暂不支持美国居民线上开户。如您选择“是”，将不能继续',
      confirmButtonText: '我已明白'
    })
      .then(() => {
        form.isAmericanGreenCardHolder = 0
      })
      .catch(() => {
        //
      })
  }
}

const changeDisclosureType1 = (name: number) => {
  if (name === 12 && !form.disclosureType1.includes(12)) {
    Dialog.alert({
      title: '提示',
      message: '由于无法使用您的个人资料，将不能继续开户',
      confirmButtonText: '我已明白'
    })
      .then(() => {
        //
      })
      .catch(() => {
        //
      })
  }
}
const validateDisclosure = (val: number[]) => {
  if (!val.includes(12)) {
    return '请同意个人资料收集声明'
  }
  return ''
}

// 按钮禁用
const hasTax = computed(() =>
  form.openAccountTaxationList.every(
    (item: TaxType) =>
      (item.hasTaxNumber === 1 && item.taxCountry !== '' && item.taxNumber !== '') ||
      (item.hasTaxNumber === 0 &&
        item.taxCountry !== '' &&
        item.reasonType === 'B' &&
        item.reasonDesc !== '') ||
      (item.hasTaxNumber === 0 &&
        item.taxCountry !== '' &&
        (item.reasonType === 'C' || item.reasonType === 'A'))
  )
)
const isDisabled = computed(() => {
  const result = form.disclosureType1.includes(12) && hasTax.value
  return !result
})

// 保存下一步调用接口
const saveNext = () => {
  const percentage = stepPercentage(step)
  commomParams.value = {
    openType: openType.value,
    openStatus: 0,
    btnText: '继续开户',
    remark: `已完成${percentage}%，请继续完善资料`,
    step
  }
  saveClientDraft({
    param: {
      formType: formTypeVal.value,
      meta: meta.value,
      content: JSON.stringify(form)
    },
    commomParams: {
      formType: formTypeVal.value,
      meta: 'open_common',
      content: JSON.stringify(commomParams.value)
    }
  })
}
const handleNext = () => {
  saveNext()
}

const toFile = (name: string) => {
  window.location.href = `${process.env.VUE_APP_H5_STATIC_PAGE_URL + '/static_pages/' + name}`
}
const tips = computed(() =>
  openType.value === 1 ? '同时支持港美股市场交易' : '同时支持港美股、A股市场交易'
)

// 查询数据字典
const { onResult } = useQuery(queryApi.findDictOpenAccount, {
  params: {
    markList: ['DISCLOSURE_CODE']
  }
})

onResult((res) => {
  const { findDictOpenAccount } = res.data
  if (findDictOpenAccount.ok) {
    const checkedList = findDictOpenAccount.data.DISCLOSURE_CODE.filter(
      (item: { value: string }) =>
        item.value === '12' || item.value === '36' || item.value === '37' || item.value === '38'
    )
    disclousreList.value = checkedList.map((val: { name: string; value: string }) => ({
      text: val.name,
      name: Number(val.value)
    }))
  }
})

// 存储缓存表方法
const { mutate: saveClientDraft, onDone } = useMutation(dobuleSaveDraft)

onDone((res) => {
  const { saveClientFormDraft, commonDraft } = res.data
  if (saveClientFormDraft.ok && commonDraft.ok) {
    saveCommonOfVuex({ info: commomParams.value })
    saveOpenInfoOfVuex({ info: form })
    router.push({ name: 'risk' })
  }
})
onMounted(() => {
  setApptitle(title)
  initData()
})

return (_ctx: any,_cache: any) => {
  const _component_popup = _resolveComponent("popup")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: handleNext,
    current: 1,
    isDisabled: isDisabled.value,
    form: form,
    prePathName: "financial-info"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "title",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
          }, _cache[15] || (_cache[15] = [
            _createTextVNode("税务信息"),
            _createElementVNode("i", { class: "iconfont icon-tishi" }, null, -1)
          ])),
          _createElementVNode("div", {
            class: "right",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toFile('accinfo_statement.html')))
          }, _cache[16] || (_cache[16] = [
            _createElementVNode("span", null, "自动交换财务账户资料", -1),
            _createElementVNode("i", { class: "iconfont icon-you" }, null, -1)
          ]))
        ]),
        _createVNode(_component_popup, {
          show: show.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
          onClosePopup: closePopup,
          onClickOverlay: _cache[3] || (_cache[3] = () => (show.value = false))
        }, null, 8, ["show"]),
        _createVNode(TaxCard, {
          onChangeTax: changeTax,
          form: form.openAccountTaxationList[0],
          onChangeTaxCountry: _cache[4] || (_cache[4] = val => (form.openAccountTaxationList[0].taxCountry = val)),
          onChangeReasonType: _cache[5] || (_cache[5] = val => (form.openAccountTaxationList[0].reasonType = val)),
          onChangeReasonDesc: _cache[6] || (_cache[6] = val => (form.openAccountTaxationList[0].reasonDesc = val)),
          onChangeReason: _cache[7] || (_cache[7] = val => (form.openAccountTaxationList[0].reason = val)),
          onChangeHasTaxNumber: _cache[8] || (_cache[8] = val => (form.openAccountTaxationList[0].hasTaxNumber = val)),
          onChangeTaxNumber: _cache[9] || (_cache[9] = val => (form.openAccountTaxationList[0].taxNumber = val))
        }, null, 8, ["form"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxArr, (item, index) => {
          return (_openBlock(), _createBlock(TaxCard, {
            key: item,
            taxIndex: index + 1,
            onDeleteTax: deleteTax,
            form: form.openAccountTaxationList[index + 1],
            onChangeReasonType: val => (form.openAccountTaxationList[index + 1].reasonType = val),
            onChangeTaxCountry: val => (form.openAccountTaxationList[index + 1].taxCountry = val),
            onChangeReasonDesc: val => (form.openAccountTaxationList[index + 1].reasonDesc = val),
            onChangeReason: val => (form.openAccountTaxationList[index + 1].reason = val),
            onChangeHasTaxNumber: val => (form.openAccountTaxationList[index + 1].hasTaxNumber = val),
            onChangeTaxNumber: val => (form.openAccountTaxationList[index + 1].taxNumber = val),
            hasDeleteIcon: true,
            onChangeTax: changeTax2
          }, null, 8, ["taxIndex", "form", "onChangeReasonType", "onChangeTaxCountry", "onChangeReasonDesc", "onChangeReason", "onChangeHasTaxNumber", "onChangeTaxNumber"]))
        }), 128)),
        _createElementVNode("div", {
          class: "btn-add",
          onClick: addTax
        }, _cache[17] || (_cache[17] = [
          _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }, null, -1),
          _createTextVNode(" 添加更多 ")
        ])),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "tip" }, " 在特定情况下，如出国留学，海外工作或长期旅行，可能会导致您成为超过一个国家的居民（即多重税务居民地）。如您在多个地区拥有税务居民身份，请提供所有信息。 ", -1)),
        _createElementVNode("div", {
          class: "material",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (toFile('personal_info.html')))
        }, _cache[18] || (_cache[18] = [
          _createElementVNode("div", { class: "title" }, "个人资料使用", -1),
          _createElementVNode("div", { class: "right" }, [
            _createElementVNode("span", null, "个人资料收集声明"),
            _createTextVNode(),
            _createElementVNode("i", { class: "iconfont icon-you" })
          ], -1)
        ])),
        _createVNode(_component_van_field, {
          name: "disclosureType1",
          rules: [{ validator: validateDisclosure }]
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_checkbox_group, {
              modelValue: form.disclosureType1,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.disclosureType1) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disclousreList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_van_checkbox, {
                    key: item.name,
                    name: item.name,
                    onClick: ($event: any) => (changeDisclosureType1(item.name))
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(`iconfont ${form.disclosureType1.includes(item.name)
                    ? 'icon-duoxuanxuanzhong'
                    : 'icon-duoxuanweixuanzhong'
                  }`
                  )
                      }, null, 2)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["name", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createElementVNode("div", {
          class: "material",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (toFile('fatca.html')))
        }, _cache[19] || (_cache[19] = [
          _createElementVNode("div", { class: "title" }, "FATCA声明", -1),
          _createElementVNode("div", { class: "right" }, [
            _createElementVNode("span", null, "海外税收合规法案"),
            _createTextVNode(),
            _createElementVNode("i", { class: "iconfont icon-you" })
          ], -1)
        ])),
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "option-title" }, "阁下是否为美国公民、居民（包括绿卡持有者）或纳税人？", -1)),
        _createVNode(_component_van_radio_group, {
          modelValue: form.isAmericanGreenCardHolder,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.isAmericanGreenCardHolder) = $event)),
          direction: "horizontal",
          onChange: changeRadio
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(radioGroup, (item) => {
              return _createVNode(_component_van_radio, {
                key: item.name,
                name: item.name
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("i", {
                    class: "iconfont icon-xuanze1",
                    style: _normalizeStyle({
              color: form.isAmericanGreenCardHolder == item.name ? '#FFB400' : '#A5B2DC'
            })
                  }, null, 4)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["name"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "agree" }, "本人同意将所属的纳税国家/地区和税务编号信息填入《W8ben》表中。", -1)),
        (formTypeVal.value === _unref(FormType).OPEN_ACCOUNT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[20] || (_cache[20] = [
              _createTextVNode(" 账户类型 "),
              _createElementVNode("div", { class: "tips" }, "请选择您需要开通的交易账户", -1)
            ])))
          : _createCommentVNode("", true),
        (formTypeVal.value === _unref(FormType).OPEN_ACCOUNT)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_van_radio_group, {
                modelValue: fundAccountType.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((fundAccountType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio, { name: 1 }, {
                    icon: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "iconfont icon-xuanze1",
                        style: _normalizeStyle({ color: fundAccountType.value ? '#FFB400' : '#A5B2DC' })
                      }, null, 4)
                    ]),
                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createElementVNode("div", { class: "cash-account" }, "现金账户", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["isDisabled", "form"]))
}
}

})